import useAccessControls, {
  PermissionProps,
} from 'modules/access-controls/atoms/use-access-controls';
import {Outlet} from 'react-router-dom';
import DashboardLayout from 'shared/layout/dashboard';
import NotFound from 'shared/layout/not-found';

interface GetElementProps {
  element: React.ReactNode;
  permissions?: PermissionProps[];
  hideDrawer?: boolean;
  wrapper?: boolean;
}

const getElement = ({
  element,
  permissions,
  hideDrawer,
  wrapper,
}: GetElementProps) => {
  const {isModuleAllowed} = useAccessControls();
  if (permissions && !isModuleAllowed(permissions)) return <NotFound />;

  return (
    <>
      <DashboardLayout {...{hideDrawer, wrapper}}>{element}</DashboardLayout>
      <Outlet />
    </>
  );
};

export default getElement;
